package app.smartcoding.realrate.platform

import app.smartcoding.realrate.domain.model.AuthUser
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.auth
import kotlinx.coroutines.flow.first

actual suspend fun ensureUserIsSignedIn(onResult: (AuthUser) -> Unit) {
    val auth = Firebase.auth
    val currentUser = auth.authStateChanged.first()
    val authUser: AuthUser = currentUser?.let { currentUser ->
        AuthUser.User(
            displayName = currentUser.displayName,
            email = currentUser.email,
            photoUrl = currentUser.photoURL,
            uid = currentUser.uid
        )
    } ?: AuthUser.Unknown
    onResult(authUser)
}